
exports.Filter = (parent, filter = {}) ->
    self = this
    ko.bindingHandlers.element =
        init: (ele, valueAccessor, allBindings, viewModel, bindingContext) ->
            viewModel.ele = ele

    @enableFilter = () ->
        self.visible true
        self.enabled true


    @disableFilter = () ->
        self.visible false
        self.enabled false


    @assignDisplayName = (name) ->
        self.display_name name


    @changeControlType = (type, repopulate = true) ->
        @control_type = type
        if repopulate
            @populateSelectedValues(@selected_values(), true)


    ###
    Fires when a value is clicked/selected in the filter list.
    ###
    @selectFilter = (item, e, refresh = true) ->
        if item?
            return self.applyFilter item, refresh, e

    ###
    Fires when a option is clicked/selected in the filter list.
    ###
    @selectOptionFilter = (item, e, refresh = true) ->
        if item.disabled
            return

        if self.deletable and item.extra_class() is 'active'
            # Workaround to remove the unwanted 'active' class applied to the item by bootstrap(?)
            setTimeout (-> $(e.target).removeClass 'active'), 0
            return self.unselectFilter item
        else
            return self.applyFilter item, refresh, e

    ###
    This is responsible for adding the filter to the selected_values list,
    as well as setting the visible attribute false on the original item so
    it is no longer listed in the actual list of filter values
    ###
    @applyFilter = (item, allow_refresh = false, e = {}) ->
        if not item?
            return
        newitem = {
            key: item.key
            value: item.value
            isSelectedInParent: ko.computed () ->
                s = self.findVal(item.key, self.values())
                if s is false or self.values()[s].visible is false
                    return false
                return true
            filterColor: ko.computed () ->
                c = self.findVal( item.value, self.colors )
                if c isnt false then return self.colors[c].color else return ''
        }

        if self.control_type is 'datepicker'
            self.selected_values.removeAll()

            if item.key? and item.value?
                val = item.key
            else if e.target?
                val = $(e.target).val()

            if val
                self.selected_values.push
                    key: val
                    value: val
                    isSelectedInParent: () ->
                        return true
                    filterColor: () ->
                        c = self.findVal( item.value, self.colors )
                        if c isnt false then return self.colors[c].color else return ''

        if self.control_type is 'daterangepicker'
            # Picker is passed as second parameter to event
            picker = allow_refresh
            self.selected_values.removeAll()

            # TODO: this should really be so its in utc
            #    key: JSON.stringify
            #        start: picker.startDate
            #        end: picker.endDate
            # but because we have `date` columns in the db we can't
            self.selected_values.push
                key: JSON.stringify
                    start: picker.startDate.format()
                    end: picker.endDate.format()
                value: "#{picker.startDate.format('MM/DD')} to #{picker.endDate.format('MM/DD')}"
                isSelectedInParent: () ->
                    return true
                filterColor: () ->
                    c = self.findVal( item.value, self.colors )
                    if c then return self.colors[c].color else return ''

        else if self.control_type is 'text'
            self.selected_values.removeAll()

            if item.key? and item.value?
                val = item.key
            else if e.target?
                val = $(e.target).val()

            if val
                self.selected_values.push
                    key: val
                    value: val
                    isSelectedInParent: () ->
                        return true
                    filterColor: () ->
                        return ''

        else if self.control_type is 'dropdown'
            if self.findVal(item.key, self.selected_values()) is false
                self.selected_values.push newitem

        else if self.control_type is 'single_dropdown'
            self.selected_values.removeAll()
            self.selected_values.push newitem

        else if self.control_type is 'option'
            # if there's already a value selected, find it's source in the
            # self.values() array, and ensure it no longer has the "active" class
            # appended to it's css
            if self.selected_values().length > 0
                old_value = self.findVal(self.selected_values()[0].key, self.values())
                if old_value
                    self.values()[old_value].extra_class ''
                self.selected_values.removeAll()

            # then, add our new value to selected values
            # and set it's source in self.values() to have the active class
            # so that it's button appears selected
            self.selected_values.push newitem

            new_value = self.findVal(item.key, self.values())

            if new_value isnt false
                self.values()[new_value].extra_class 'active'

        if self.onFilterApplied?
            self.onFilterApplied(self, self.selected_values)

        if allow_refresh
            parent.fetchFilters()

    ###
    Fires when a value is selected to be removed from the applied filters.

    This is responsible for removing the clicked item from selected_values,
    and un-hiding the value back in the actual list of filter values (if it is still in the list)
    ###
    @unselectFilter = (item) ->
        # Un-apply active class to options upon delete
        if self.control_type is 'option'
            value = self.findVal(item.key, self.values())
            if value isnt false
                self.values()[value].extra_class ''
            self.selected_values.removeAll()

        self.selected_values.remove item
        if self.refresh_on_delete is true
            parent.fetchFilters()


    ###
    Quick shortcut/utility method for finding a value in any of our arrays,
    by some kind of object key.
    ###
    @findVal = (key, arr, attr = 'key') ->
        for v, k in arr
            if v[attr] is key
                return k
        return false

    ###
    Ensures filter values are populated correctly
    ###
    @populateValues = (vals) ->
        $.each vals, (index, v) ->
            v.visible = ko.computed () ->
                self.findVal(v.key, self.selected_values()) is false

            v.filterColor   = ko.computed () ->
                c = self.findVal( v.key, self.colors )
                if c isnt false then return self.colors[c].color else return ''

            v.extra_class   = ko.observable ''

            if self.control_type is 'option'
                selected_item = self.findVal(v.key, self.selected_values())
                if selected_item isnt false
                    if v.disabled
                        # Unselect disabled items in toggles
                        self.unselectFilter selected_item
                    else
                        # Reapply active to selected items
                        v.extra_class 'active'

            if v.disabled
                v.extra_class 'disabled'

        self.values.removeAll()

        ko.utils.arrayPushAll self.values(), vals
        self.values.valueHasMutated()


    ###
    Can be used to populate defaults
    ###
    @populateSelectedValues = (vals, refresh = true) ->
        for v in vals
            self.selectFilter v, {}, refresh


    ###
    On construction
    ###
    self.name                   = filter.name ? ''
    self.display_name           = ko.observable filter.display_name ? ''
    self.control_type           = filter.control_type ? 'dropdown'
    self.auto_select_only_value = filter.auto_select_only_value ? false
    self.auto_select_first      = filter.auto_select_first ? false
    self.auto_clear_unavailable      = filter.auto_clear_unavailable ? false
    self.auto_select_by_default_flag      = filter.auto_select_by_default_flag ? false

    self.force_select_an_option      = filter.force_select_an_option ? false
    self.deletable              = filter.deletable ? true
    self.class                  = ko.observable filter.class ? ''
    self.colors                 = filter.colors ? []
    self.values                 = ko.observableArray()
    self.enable_depends         = filter.enable_depends ? true
    self.visible_depends        = filter.visible_depends ? true
    self.visible                = ko.observable filter.visible ? true
    self.enabled                = ko.observable filter.enable ? true
    self.refresh_on_delete      = filter.refresh_on_delete ? true

    self.listenForYear          = filter.listenForYear if filter.listenForYear?
    self.onFilterApplied        = filter.onFilterApplied if filter.onFilterApplied?

    self.selected_values        = ko.observableArray()

    self.populateValues(filter.values ? [])

    self.populateSelectedValues(filter.selected_values ? [], false)

    self.anyVisible = ko.computed () ->
        for v in self.values()
            if v.visible()
                return true

        return false

    @VisDep = ko.computed () ->
        if Array.isArray self.visible_depends
            for f in self.visible_depends
                filter = parent.findInGroup f.key
                if not filter
                    return true
                for sv in filter.selected_values()
                    if sv.value isnt f.value
                        if self.control_type is 'datepicker'
                            self.selected_values.removeAll()
                        return false
            return true
        else
            return self.visible_depends

    @EnableDep = ko.computed () ->
        if Array.isArray self.enable_depends
            for f in self.enable_depends
                filter = parent.findInGroup f.key
                if not filter
                    return true
                for sv in filter.selected_values()
                    if sv.value isnt f.value
                        if self.control_type is 'datepicker'
                            self.selected_values.removeAll()
                        return false
            return true
        else
            return self.enable_depends

    ###
    self.fetch = () ->
        if $.isArray self.source
            self.value(self.source)
    ###

    return self
